<template>
  <div>
    <PageHeader title="การรับหนังสือที่สถาบัน"></PageHeader>
    <b-container class="mt-5 px-5" fluid>
      <div class="card card-csq no-shadow">
        <div class="card-body search-section">
          <b-row>
            <b-col cols="4">
              <label><strong>ชื่อผู้เรียน</strong></label>
              <b-form-input
                v-model="studentName"
                type="search"
                class="form-control border-1"
                autofocus
                placeholder="ค้นหาชื่อผู้เรียน"
              ></b-form-input>
            </b-col>
            <b-col cols="4">
              <label><strong>ชื่อคอร์สเรียน</strong></label>
              <b-form-input
                v-model="courseName"
                type="search"
                class="form-control border-1"
                autofocus
                placeholder="ค้นหาจากคอร์สเรียน"
              ></b-form-input>
            </b-col>
            <b-col cols="4">
              <label><strong>วันที่ชำระเงิน</strong></label>
              <div class="date-range-field">
                <b-input-group>
                  <b-form-input
                    size="sm"
                    type="text"
                    :value="formattedPaymentDate"
                    placeholder="เลือกวันที่ชำระเงิน"
                    disabled
                  />
                  <b-input-group-prepend>
                    <b-button
                      size="sm"
                      variant="secondary"
                      @click="showCalendarRange('payment-date')"
                    >
                      <b-icon icon="calendar-range"></b-icon>
                    </b-button>
                  </b-input-group-prepend>
                </b-input-group>
                <DatePicker
                  v-model="paymentDate"
                  locale="th"
                  id="payment-date"
                  style="
                    display: none;
                    float: right;
                    position: relative;
                    will-change: transform;
                    left: 0px;
                  "
                  is-range
                />
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <label><strong>สถานะการรับหนังสือ</strong></label>
              <b-form-select
                v-model="selectedPickupStatus"
                :options="pickupStatusOptions"
              ></b-form-select>
            </b-col>
            <b-col cols="4">
              <label><strong>รูปแบบคอร์ส</strong></label>
              <b-form-select
                v-model="selectedCourseType"
                :options="courseTypeOptions"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-button
            @click="searchPickupInfo()"
            class="search-btn"
            block
            variant="primary"
          >
            ค้นหา
          </b-button>
        </div>
        <hr />
        <div class="card-body detail-section">
          <b-row class="pb-3" style="border-bottom: 1px solid #000">
            <b-col cols="2">
              <p><strong>ชื่อผู้เรียน</strong></p>
            </b-col>
            <b-col cols="2">
              <p><strong>วันที่ชำระเงิน</strong></p>
            </b-col>
            <b-col cols="3">
              <p><strong>คอร์สเรียน</strong></p>
            </b-col>
            <b-col cols="2">
              <p><strong>จำนวนหนังสือ</strong></p>
            </b-col>
            <b-col cols="2">
              <p><strong>สถานะการรับหนังสือ</strong></p>
            </b-col>
            <b-col cols="1">
              <p><strong></strong></p>
            </b-col>
          </b-row>

          <template v-if="isLoading">
            <Loading />
          </template>
          <template v-else-if="groupedBooks.length == 0">
            <p class="text-center py-4">ไม่มีข้อมูล</p>
          </template>
          <div v-else class="">
            <b-row
              v-for="(item, index) in filterBookDeliveryList"
              :key="index"
              :class="[
                activeIndex == index
                  ? 'activeRow pt-2 mb-2'
                  : 'defaultRow py-2',
                'onHover  ',
              ]"
            >
              <b-col cols="2" class="action-col">
                <p>{{ item.memberName || "-" }}</p>
              </b-col>
              <b-col cols="2" class="action-col">
                <p>{{ item.coActualPurchaseDateTime | thaiDateFilter }}</p>
              </b-col>
              <b-col cols="3" class="action-col">
                <p>
                  {{ item.cCourseCode || "-" }}
                  {{ item.courseName || "-" }}
                </p>
              </b-col>
              <b-col cols="2" class="action-col">
                <p>{{ item?.books?.length }}</p>
              </b-col>
              <b-col cols="2" class="action-col">
                <p>
                  {{ bookDeliveryStatus(item.books) }}
                </p>
              </b-col>
              <b-col cols="1" class="action-col">
                <b-button
                  v-b-toggle="'collapse-pickup-' + index"
                  :variant="
                    activeIndex == index ? 'primary' : 'outline-primary'
                  "
                  @click="
                    activeIndex == index
                      ? (activeIndex = null)
                      : (activeIndex = index)
                  "
                >
                  ดูข้อมูล
                </b-button>
              </b-col>

              <b-collapse
                :id="'collapse-pickup-' + index"
                style="background-color: #fff"
                accordion="my-accordion"
                class="w-100"
              >
                <b-col cols="12" class="my-2">
                  <b-row
                    v-for="(book, bookIndex) in item.books"
                    :key="bookIndex"
                    class="py-2"
                  >
                    <b-col cols="2"></b-col>
                    <b-col cols="2" class="text-right">
                      <p v-if="bookIndex == 0"><strong>ชื่อหนังสือ</strong></p>
                    </b-col>
                    <b-col cols="3">
                      <p>{{ book.bookName }}</p>
                    </b-col>
                    <b-col cols="2"> </b-col>
                    <b-col cols="2">
                      <b-button
                        class="pickup-book-btn"
                        variant="success"
                        :disabled="book.bdStatus === 'DELIVERED'"
                        @click="pickupBook(book.bdId)"
                      >
                        {{
                          book.bdStatus === "DELIVERED"
                            ? "รับแล้ว"
                            : "รับหนังสือ"
                        }}
                      </b-button>
                    </b-col>
                    <b-col cols="1">
                      <p v-if="book.bdStatus === 'DELIVERED'">
                        {{ book.bdTimestamp | thaiDateFilter }}
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-collapse>
            </b-row>
          </div>
          <!-- pagination -->
          <b-row class="mt-4">
            <b-col cols="6 ">
              <div class="d-flex justify-content-start align-items-center">
                <p class="pr-3">แสดง</p>
                <b-form-select
                  v-model="perPage"
                  :options="[5, 10, 15, 30, 50]"
                  style="width: 75px"
                >
                </b-form-select>
                <p class="pl-3">จาก {{ totalRows }} รายการ</p>
              </div>
            </b-col>
            <b-col cols="6">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="right"
                last-number
              ></b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import Loading from "@/components/shared/Loading";
import moment from "moment";
import dateMixin from "@/components/pages/analytics/shared/mixins/date.js";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [dateMixin],
  components: {
    PageHeader,
    DatePicker,
    Loading,
  },
  computed: {
    ...mapGetters("BookManagement", ["bookDeliveryList"]),
    groupedBooks() {
      const pickupInfo = this.bookDeliveryList.filter(
        (item) => item.bdType === "PICKUP",
      );
      const grouped = pickupInfo.reduce((acc, current) => {
        const id = current.coOrderNumber;
        let data = {
          bdId: current.bdId,
          bookCode: current.bookCode,
          bookName: current.bookName,
          bdStatus: current.bdStatus,
          bdTimestamp: current.bdTimestamp,
        };

        if (!acc[id]) {
          acc[id] = {
            ...current,
            books: [data],
          };
        } else {
          acc[id].books.push(data);
        }

        return acc;
      }, {});

      // Convert map to array and sort by date
      return Object.values(grouped).sort((a, b) => {
        // Newest first (descending). Reverse 'b' and 'a' for oldest first.
        return (
          new Date(b.coActualPurchaseDateTime) -
          new Date(a.coActualPurchaseDateTime)
        );
      });
    },
    filterBookDeliveryList() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      let data = this.groupedBooks.slice(start, end);
      return data;
    },
    formattedPaymentDate() {
      return this.getFormattedRange(
        this.paymentDate.start,
        this.paymentDate.end,
        "payment-date",
      );
    },
    totalRows() {
      if (this.groupedBooks.length > 0) {
        return this.groupedBooks.length;
      }
      return 0;
    },
  },
  data() {
    return {
      studentName: "",
      courseName: "",
      paymentDate: {
        start: "",
        end: "",
      },
      selectedPickupStatus: "",
      pickupStatusOptions: [
        { value: "", text: "สถานะทั้งหมด" },
        { value: "DELIVERED", text: "รับหนังสือแล้ว" },
        { value: "NOT_DELIVERED", text: "ยังไม่ได้รับหนังสือ" },
        { value: "PARTIALLY_DELIVERED", text: "รับหนังสือไม่ครบ" },
      ],
      selectedCourseType: "",
      courseTypeOptions: [
        { value: "", text: "รูปแบบคอร์สทั้งหมด" },
        { value: "ONSITE", text: "คอร์สเรียนรอบสอนสด" },
        { value: "ONLINE", text: "คอร์สเรียนออนไลน์" },
      ],
      selectedPerPage: 5,
      perPage: 5,
      currentPage: 1,
      isLoading: false,
      activeIndex: null,
    };
  },
  mounted() {
    this.fetch(null);
  },
  methods: {
    ...mapActions("BookManagement", [
      "fetchBookDeliveryList",
      "updateBookDelivery",
    ]),
    async fetch(params) {
      this.isLoading = true;
      await this.fetchBookDeliveryList(params);
      this.isLoading = false;
    },
    searchPickupInfo() {
      let params = {
        memberName: this.studentName,
        orderStatus: this.selectedPickupStatus,
        courseName: this.courseName,
        cType: this.selectedCourseType,
        purchaseDateFrom: this.paymentDate.start
          ? moment(this.paymentDate.start).format("YYYY-MM-DD")
          : "",
        purchaseDateTo: this.paymentDate.end
          ? moment(this.paymentDate.end).format("YYYY-MM-DD")
          : "",
      };
      this.fetch(params);
    },
    async pickupBook(id) {
      let params = {
        bdId: id,
        attribute: {
          bdStatus: "DELIVERED",
          bdTimestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
        },
      };
      await this.updateBookDelivery(params);
      await this.fetch(null);
    },
    bookDeliveryStatus(books) {
      const allDelivered = books.every((book) => book.bdStatus === "DELIVERED");
      const allNotDelivered = books.every(
        (book) => book.bdStatus === "NOT_DELIVERED",
      );

      return allDelivered
        ? "รับหนังสือครบ"
        : allNotDelivered
        ? "ยังไม่ได้รับหนังสือ"
        : "รับหนังสือไม่ครบ";
    },
    showCalendarRange(calendarId) {
      let rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar.style.display == "inline-block") {
        rangeCalendar.style.display = "none";
      } else {
        rangeCalendar.style.display = "inline-block";
      }
    },
    getFormattedRange(startDate, endDate, calendarId) {
      if (!startDate) return "";

      const rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar && rangeCalendar.style.display === "inline-block") {
        this.showCalendarRange(calendarId);
      }

      const start = moment(startDate).format("DD/MM/YYYY");
      const end = moment(endDate).format("DD/MM/YYYY");
      return `${start} - ${end}`;
    },
  },
};
</script>

<style scoped lang="scss">
/* Calendar */
.vc-container {
  position: absolute !important;
  right: 0 !important;
  left: initial !important;
  margin-right: 13px;
  z-index: 99;
}

/* Target the input search and its placeholder */
::v-deep .vs__search,
::v-deep .vs__search::placeholder {
  margin: 0;
  padding: 3px 3px 2px;
  font-size: 14px;
}

.search-section {
  display: flex;
  flex-direction: column;
  gap: 24px;

  .search-btn {
    width: fit-content;
  }
}

.detail-section {
  .pickup-book-btn {
    width: 110px;
  }
}

.defaultRow:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.activeRow {
  background-color: #e7f1ff;

  .action-col {
    padding-bottom: 8px;
  }
}
</style>

<style>
/* text field height */
.date-range-field .form-control,
.vs__dropdown-toggle {
  height: 38px;
}

.vs__dropdown-toggle {
  align-items: center;
}

.custom-select {
  height: 38px !important;
  padding: 0 1.75rem 0 0.75rem;
  font-size: 14px !important;
}
</style>
